import React, { useEffect } from "react";
import { DatePicker, Flex, Modal } from "antd";
import { Button, Form, Input } from "antd";
import { getMonth, getYear, isBefore, startOfToday } from "date-fns";
import { useTranslation } from "react-i18next";
import { BASE_API_URL } from "../../../../utils/consts";
import axios from "axios";
import { List, Typography } from "antd";
import { format } from "date-fns";
import TextArea from "antd/es/input/TextArea";

const { Text } = Typography;
type Props = {
  isOpen: boolean;
  onCloseModal: () => void;
  mode?: "create" | "edit";
  modalData?: any;
  selectedMonth: any;
  userId: any;
  onUpdate: () => void;
};

const TravelExpensesModal: React.FC<Props> = ({
  isOpen,
  onCloseModal,
  mode = "create",
  modalData,
  selectedMonth,
  userId,
  onUpdate,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleOk = () => {
    onCloseModal();
    form.resetFields();
  };

  const handleCancel = () => {
    onCloseModal();
    form.resetFields();
  };
  const onFinish = async (values: any) => {
    if (mode === "create") {
      axios
        .post(`${BASE_API_URL}/userPayments/`, {
          userId: userId,
          travelExpenses: {
            date: values.date,
            total: values.total,
            description: values.description,
          },
        })
        .then(() => {
          onUpdate();
        });
    } else {
      if (!modalData) return;
      axios
        .put(
          `${BASE_API_URL}/userPayments/${modalData._id}/${modalData.userId._id}`,
          {
            travelExpenses: {
              date: values.date,
              total: values.total,
              description: values.description,
            },
          }
        )
        .then(() => onUpdate())
        .catch();
    }
    onCloseModal();
  };

  useEffect(() => {}, []);

  const disabledPast = (current: any) => {
    return current && isBefore(current.toDate(), startOfToday());
  };

  //Fixed price calculation
  function getAverageSalaryForMonth(salaries: any, year: any, month: any) {
    if (!salaries && !salaries?.length) return;
    const monthStart = new Date(year, month, 1);
    const monthEnd = new Date(year, month + 1, 0, 23, 59, 59);

    // Sortiraj po startDate, a ako je isti datum, zadrži poslednji u arrayu
    const sorted = [...salaries].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );

    // Mapiramo po danima u mesecu → koji je salary važio
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    let totalWeighted = 0;

    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day, 23, 59, 59);

      // Nadji sve plate koje su počele pre ili tog dana
      const validSalaries = sorted.filter(
        (s) => new Date(s.date).getTime() <= currentDate.getTime()
      );

      if (validSalaries.length > 0) {
        // Uzimamo zadnji (poslednji koji važi tog dana)
        const lastSalary = validSalaries[validSalaries.length - 1];
        totalWeighted += lastSalary.totalPrice;
      }
    }

    return Math.round(totalWeighted / daysInMonth);
  }

  //   if (!modalData[0]) return <></>;
  return (
    <Modal
      title={<div className="">{t("Travel Expenses")}</div>}
      open={isOpen}
      onOk={handleOk}
      className="standardHeader"
      onCancel={handleCancel}
      footer={[]}
    >
      <List
        itemLayout="horizontal"
        dataSource={modalData && modalData.travelExpenses}
        renderItem={(item: any) => (
          <List.Item>
            <Text>{format(new Date(item.date), "yyyy-MM-dd")}</Text>
            <Text style={{ marginLeft: 16 }}>{item.total} RSD</Text>
          </List.Item>
        )}
      />
      <div>
        Total:{" "}
        {getAverageSalaryForMonth(
          modalData && modalData?.fixedPrice,
          getYear(new Date(selectedMonth)),
          getMonth(new Date(selectedMonth))
        )}
      </div>
      <Form
        name="fixedPaymentForm"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="date"
          label={t("Date")}
          rules={[{ required: true, message: t("Please select date!") }]}
        >
          <DatePicker
            // disabledDate={disabledPast}
            placeholder={t("Select date")}
          />
        </Form.Item>

        <Form.Item
          name="total"
          label={t("Percentage Salary")}
          rules={[
            { required: true, message: t("Please enter percentage salary!") },
          ]}
        >
          <Input type="number" placeholder={t("Enter salary")} />
        </Form.Item>
        <Form.Item
          label={t("Description")}
          name="description"
          rules={[{ required: false, message: t("Please enter description") }]}
        >
          <TextArea rows={2} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Flex gap="small" wrap="wrap">
            <Button type="primary" htmlType="submit">
              {t("Save")}
            </Button>
            {/* {mode !== "create" && (
              <Button danger onClick={handleCancel}>
                {t("Delete")}
              </Button>
            )} */}
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TravelExpensesModal;
